import { useTheme } from "@mui/material"


export const useStyles = () => {
    const { palette } = useTheme()
    return {
        container: {
            position: 'relative',
            width: '10px',
            height: '10px',
            justifyItems: 'center'
        },
        mark: {
            position: 'absolute',
            justifyItems: 'center',
            top: '-85px', left: '50%',
            transform: 'translateX(-50%)',
            //width: "max-content",
            //maxWidth: "200px",
            //textAlign: "center"
        },
        header: (color: string) => ({
            fontSize: "12px",
            backgroundColor: color,
            color: "white",
            //display: "inline-block",
            //maxWidth: "200px",
            padding: "2px 6px",
            borderRadius: "4px",
            //whiteSpace: "normal",
            whiteSpace: 'nowrap',
            overflowWrap: "break-word",
            wordBreak: "keep-all",
            marginBottom: '5px',
            width: 'fit-content',
            
        }),
        containerMark: {
            position: 'relative'
        },
        user: {
            fontSize: '12px',
            backgroundColor: 'white',
            position: 'absolute',
            right: '-40px',
            padding: '4px',
            borderRadius: '4px',
            width: '300px'
        }
    }
}